import * as t from "io-ts";
import { Pence } from "./Pence";

export const IntroductionStats = t.type({
  branch_code: t.string,
  branch_name: t.string,
  introductions_sent: Pence,
  introductions_completed: Pence,
  order_details_added: Pence,
  tradesperson_approved: Pence,
  finance_applications: Pence,
  approve_applications: Pence,
  potential_revenue: Pence,
  job_revenue: Pence,
  average_job_value: Pence,
  total_revenue: Pence,
  average_order_value: Pence,
  approval_rate: Pence,
});

export interface IntroductionStats {
  branch_code: string;
  branch_name: string;
  introductions_sent: Pence;
  introductions_completed: Pence;
  order_details_added: Pence;
  tradesperson_approved: Pence;
  finance_applications: Pence;
  approve_applications: Pence;
  potential_revenue: Pence;
  job_revenue: Pence;
  average_job_value: Pence;
  total_revenue: Pence;
  average_order_value: Pence;
  approval_rate: Pence;
}
